import { state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const prismsUsers = {
  state,
  mutations,
  actions
};
